import React from "react"
import { twMerge } from "tailwind-merge"

import {
  normalizeServiceImageObjectFit,
  serviceImageObjectFitClass,
  type ServiceCardObjectFit
} from "../../utils/serviceCardImageUtils"

type ServiceCardImageProps = {
  src: string
  alt: string
  className?: string
  hoverClassName?: string
  objectFit?: ServiceCardObjectFit
  onError?: React.ReactEventHandler<HTMLImageElement>
  style?: React.CSSProperties
}

export default function ServiceCardImage({
  src,
  alt,
  className,
  hoverClassName,
  objectFit = "cover",
  onError,
  style
}: ServiceCardImageProps) {
  const fit = normalizeServiceImageObjectFit(objectFit)

  return (
    <img
      src={src}
      alt={alt}
      className={twMerge("size-full", serviceImageObjectFitClass(fit), hoverClassName, className)}
      style={style}
      onError={onError}
    />
  )
}
